<template>
  <div id="app">
    <AppNavbar/>
    <router-view/>
    <PageFootModule/>
  </div>
</template>

<script>
import AppNavbar from '@/components/Navbar.vue'
import PageFootModule from '@/views/home/components/PageFootModule.vue'

export default {
  name: 'App',
  components: {
    AppNavbar,
    PageFootModule
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgb(9, 7, 7);
}
</style>
